import styled from 'styled-components'

interface IToggleWrapper {
  count: number
  color: string
}

interface IToggler {
  position: number
}

export const ToggleWrapper = styled.div<IToggleWrapper>`
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 22px;
  list-style: none;
  position: relative;
  display: inline-block;
  width: ${props => props.count * 22}px;
  height: 22px;
  vertical-align: middle;
  background: ${props => props.color};
  border: 0;
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
  flex-shrink: 0;
`

export const ToggleAction = styled.button`
  height: 22px;
  width: 22px;
  background: transparent;
  border: none !important;
  font-size: 0;
`

export const Toggler = styled.div<IToggler>`
  position: absolute;
  top: 2px;
  inset-inline-start: ${props => props.position * 22 + 2}px;
  width: 18px;
  height: 18px;
  transition: all 0.2s ease-in-out;

  &::before {
    position: absolute;
    top: 0;
    inset-inline-end: 0;
    bottom: 0;
    inset-inline-start: 0;
    background-color: #fff;
    border-radius: 9px;
    box-shadow: 0 2px 4px 0 rgb(0 35 11 / 20%);
    transition: all 0.2s ease-in-out;
    content: '';
  }
`
